import React, { FC } from 'react';

import { PredictionsAccountCategories, VIEW_TYPES } from '../../../../../core/types';
import { ROW_KIND } from '../constants';
import { RowType } from '../types';
import { HeaderRowAccount } from './header-row-account';
import { HeaderRowAssumption } from './header-row-assumption';
import { HeaderRowHeading } from './header-row-heading';
import { HeaderRowPayment } from './header-row-payment';
import { HeaderRowSheetsAssumption } from './header-row-sheets-assumption';
import { HeaderRowSystemCalc } from './header-row-system-calc';

export interface Props {
  row: RowType;
  level: number;
  wrapperStyle: React.CSSProperties;
  isPayments: boolean;
  category?: PredictionsAccountCategories;
  viewType?: VIEW_TYPES;
  isFirstAssumption?: boolean;
  onManualPredictionDrawerOpen: (predictionId?: string, predictionType?: string, isQuickCopy?: boolean) => void;
}

export const HeaderRowSwitch: FC<Props> = props => {
  const { row, isPayments, isFirstAssumption } = props;

  switch (row.kind) {
    case ROW_KIND.assumption:
      return (
        <HeaderRowAssumption
          {...props}
          row={row}
          isLast={row.siblingIndex === row.siblingCount - 1}
          isFirstAssumption={isFirstAssumption}
        />
      );
    case ROW_KIND.systemCalc:
      return <HeaderRowSystemCalc {...props} row={row} isLast={row.siblingIndex === row.siblingCount - 1} />;
    case ROW_KIND.heading:
      return <HeaderRowHeading {...props} row={row} />;
    case ROW_KIND.sheetsAssumption:
      return <HeaderRowSheetsAssumption {...props} row={row} isLast={row.siblingIndex === row.siblingCount - 1} />;
    case ROW_KIND.paymentType:
      return <HeaderRowPayment {...props} row={row} isLast={row.siblingIndex === row.siblingCount - 1} />;
    default:
      return <HeaderRowAccount {...props} row={row} isPayments={isPayments} />;
  }
};
